import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaEdit } from 'react-icons/fa'; // Import edit icon
import './missonAndVision.css'
import BannerUpdate from '../../components/BannerUpdate/BannerUpadate';
import API_URL from '../../api/ExamCalendarApi';

const ManageMissionAndVision = () => {
  const [mission, setMission] = useState('');
  const [vision, setVision] = useState('');
  const [values, setValues] = useState(''); // State for values text
  const [missionImage, setMissionImage] = useState(null);
  const [visionImage, setVisionImage] = useState(null);
  const [valuesImage, setValuesImage] = useState(null); // State for values image
  const [missionImageUrl, setMissionImageUrl] = useState('');
  const [visionImageUrl, setVisionImageUrl] = useState('');
  const [valuesImageUrl, setValuesImageUrl] = useState(''); // State for values image URL
  const [editField, setEditField] = useState(null); // For managing editable fields
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Fetch existing data on load
  useEffect(() => {
    fetchMissionAndVision();
  }, []);

  const fetchMissionAndVision = async () => {
    try {
      const response = await axios.get(`${API_URL}/mission-vision/get`);
      const { mission, vision, missionImage, visionImage, values, valuesImage } = response.data.missionAndVision;

      setMission(mission || '');
      setVision(vision || '');
      setValues(values || ''); // Set values text
      setMissionImageUrl(missionImage || '');
      setVisionImageUrl(visionImage || '');
      setValuesImageUrl(valuesImage || ''); // Set values image URL
    } catch (err) {
      setError('Failed to fetch mission and vision data');
    }
  };

  const handleFileChange = (e, type) => {
    if (type === 'mission') setMissionImage(e.target.files[0]);
    if (type === 'vision') setVisionImage(e.target.files[0]);
    if (type === 'values') setValuesImage(e.target.files[0]); // Set values image
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    const formData = new FormData();
    formData.append('mission', mission);
    formData.append('vision', vision);
    formData.append('values', values); // Append values text
    if (missionImage) formData.append('missionImage', missionImage);
    if (visionImage) formData.append('visionImage', visionImage);
    if (valuesImage) formData.append('valuesImage', valuesImage); // Append values image

    try {
      const response = await axios.put(`${API_URL}/mission-vision/update`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setSuccessMessage(response.data.message);
      toast.success('Mission, Vision, and Values updated successfully!');
      fetchMissionAndVision(); // Reload updated data
    } catch (err) {
      setError('Failed to update mission, vision, and values');
    }
  };

  const handleEdit = (field) => {
    setEditField(field);
  };

  return (
    <div className='admin-missionvision-container'>
      {/* <ToastContainer /> */}
      <h2 className="admin-missionvision-heading">Manage Mission and Vision</h2>
      <BannerUpdate pageName="mission-and-vision"/>

      {error && <div className="admin-missionvision-alert error">{error}</div>}
      {successMessage && <div className="admin-missionvision-alert success">{successMessage}</div>}

      <form onSubmit={handleSubmit} className="admin-missionvision-form">
        {/* Mission Section */}
        <div className="admin-missionvision-form-group">
          <label className="admin-missionvision-label">
            Mission
            <button
              type="button"
              className="admin-missionvision-edit-button"
              onClick={() => handleEdit('mission')}
            >
              <FaEdit className="admin-missionvision-edit-icon" />
              Edit
            </button>
          </label>
          <textarea
            className="admin-missionvision-textarea"
            value={mission}
            onChange={(e) => setMission(e.target.value)}
            placeholder="Enter mission text"
            disabled={editField !== 'mission'}
          />
        </div>

        <div className="admin-missionvision-form-group">
          <label className="admin-missionvision-label">
            Mission Image
            <button
              type="button"
              className="admin-missionvision-edit-button"
              onClick={() => handleEdit('missionImage')}
            >
              <FaEdit className="admin-missionvision-edit-icon" />
              Edit
            </button>
          </label>
          <input
            className="admin-missionvision-file-input"
            type="file"
            onChange={(e) => handleFileChange(e, 'mission')}
            disabled={editField !== 'missionImage'}
          />
          {missionImageUrl && (
            <img
              src={missionImageUrl}
              alt="Mission"
              className="admin-missionvision-image"
            />
          )}
        </div>

        {/* Vision Section */}
        <div className="admin-missionvision-form-group">
          <label className="admin-missionvision-label">
            Vision
            <button
              type="button"
              className="admin-missionvision-edit-button"
              onClick={() => handleEdit('vision')}
            >
              <FaEdit className="admin-missionvision-edit-icon" />
              Edit
            </button>
          </label>
          <textarea
            className="admin-missionvision-textarea"
            value={vision}
            onChange={(e) => setVision(e.target.value)}
            placeholder="Enter vision text"
            disabled={editField !== 'vision'}
          />
        </div>

        <div className="admin-missionvision-form-group">
          <label className="admin-missionvision-label">
            Vision Image
            <button
              type="button"
              className="admin-missionvision-edit-button"
              onClick={() => handleEdit('visionImage')}
            >
              <FaEdit className="admin-missionvision-edit-icon" />
              Edit
            </button>
          </label>
          <input
            className="admin-missionvision-file-input"
            type="file"
            onChange={(e) => handleFileChange(e, 'vision')}
            disabled={editField !== 'visionImage'}
          />
          {visionImageUrl && (
            <img
              src={visionImageUrl}
              alt="Vision"
              className="admin-missionvision-image"
            />
          )}
        </div>

        {/* Values Section */}
        <div className="admin-missionvision-form-group">
          <label className="admin-missionvision-label">
            Values
            <button
              type="button"
              className="admin-missionvision-edit-button"
              onClick={() => handleEdit('values')}
            >
              <FaEdit className="admin-missionvision-edit-icon" />
              Edit
            </button>
          </label>
          <textarea
            className="admin-missionvision-textarea"
            value={values}
            onChange={(e) => setValues(e.target.value)}
            placeholder="Enter values text"
            disabled={editField !== 'values'}
          />
        </div>

        <div className="admin-missionvision-form-group">
          <label className="admin-missionvision-label">
            Values Image
            <button
              type="button"
              className="admin-missionvision-edit-button"
              onClick={() => handleEdit('valuesImage')}
            >
              <FaEdit className="admin-missionvision-edit-icon" />
              Edit
            </button>
          </label>
          <input
            className="admin-missionvision-file-input"
            type="file"
            onChange={(e) => handleFileChange(e, 'values')}
            disabled={editField !== 'valuesImage'}
          />
          {valuesImageUrl && (
            <img
              src={valuesImageUrl}
              alt="Values"
              className="admin-missionvision-image"
            />
          )}
        </div>

        {/* Submit Button */}
        <div className="admin-missionvision-submit">
          <button type="submit" className="admin-missionvision-submit-button">
            Save Mission, Vision, and Values
          </button>
        </div>
      </form>
    </div>
  );
};

export default ManageMissionAndVision;
